import { Dispatch } from "redux";
import { setLoading } from "./global";
import HelpCenterService from "service/HelpCenter";
import { showMessage } from "utilities/helper";
import { HelpCenterPayloadTypes } from "utilities/types/HelpCenter";

export const getAllHelpCenters = () => async (dispatch: Dispatch) => {
  dispatch(setLoading(true));
  try {
    const data = await HelpCenterService.getAllHelpCenters();

    dispatch(setLoading(false));
    dispatch({ type: "SET_HELP_CENTER", value: data.helps });
  } catch (err: any) {
    dispatch(setLoading(false));
    if (err.request.status !== 401) {
      console.log("error :", err);
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  }
};

export const storeHelpCenter =
  (form: HelpCenterPayloadTypes, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await HelpCenterService.storeHelpCenter(payload);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllHelpCenters() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const updateHelpCenter =
  (
    helpCenterId: string,
    form: HelpCenterPayloadTypes,
    handleCloseModal: () => void
  ) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    const payload = form;
    try {
      const data = await HelpCenterService.updateHelpCenter(
        helpCenterId,
        payload
      );

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_FORM", value: false });

      dispatch(getAllHelpCenters() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };

export const deleteHelpCenter =
  (helpCenterId: string, handleCloseModal: () => void) =>
  async (dispatch: Dispatch) => {
    dispatch({ type: "SET_FORM_LOADING", value: true });
    try {
      const data = await HelpCenterService.deleteHelpCenter(helpCenterId);

      dispatch({ type: "SET_FORM_LOADING", value: false });
      dispatch({ type: "SET_MODAL_CONFIRMATION", value: false });

      dispatch(getAllHelpCenters() as any);

      handleCloseModal();
      showMessage(data.message, "success");
    } catch (err: any) {
      console.log("error :", err);
      dispatch({ type: "SET_FORM_LOADING", value: false });
      showMessage(
        !err.response
          ? err.message
          : !!err.response?.data?.error
          ? err.response?.data?.error
          : err.response?.data?.message,
        "error"
      );
    }
  };
